import React from 'react';
import { Spin } from 'antd';

export default function Loader({ tip = 'Chargement...' }) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 300,
            width: '100%',
        }}>
            <Spin size="large" tip={tip} />
        </div>
    );
}
